import { LOCAL_STORAGE } from "@/shared/constants/FormConstants";
import { NavigationGuardNext, Route } from "vue-router";

export const RolesGuard = (
  to: Route,
  from: Route,
  next: NavigationGuardNext
) => {
  if (to.meta?.id) {
    const views = localStorage.getItem(LOCAL_STORAGE.VIEWS);

    if (views && JSON.parse(views).includes(to.meta.id)) next();
    else if (from.name !== to.name) next({ path: from.path });
    else next({ path: "/" });
  } else {
    next();
  }
};
